export const RUBY_COLOR = '#f12626'
export const COINS_COLOR = '#FFC107'
export const COINS_COLOR_DARK = '#DEA806'
export const COINS_COLOR_0x = 0xFFC107
export const COINS_COLOR_LIGHT = '#FFD54F'
export const WIN_POINTS_COLOR = '#c3c3c3'
export const WIN_POINTS_COLOR_0x = 0xc3c3c3
export const WIN_POINTS_COLOR_LIGHT = '#D8D8D8'
export const WIN_POINTS_COLOR_DARK = '#A9A9A9'
export const ACTIONS_COLOR = '#000000'

export const CONTROLS_COLOR = '#b09292'

export const SUPPLY_COLOR = '#D68A5A'
export const SUPPLY_COLOR_0x = 0xD68A5A
export const CONSTRUCTIONS_COLOR = '#865333'
export const WAR_COLOR = '#C80000'
export const WAR_COLOR_0x = 0xC80000

export const SUCCESS_COLOR = '#32a835';
export const WARNING_COLOR = '#ff9800';
export const INFO_COLOR = CONTROLS_COLOR;

export const PRIMARY_COLOR = '#841B2D'
export const SECONDARY_COLOR = '#2C2C2C';
export const BACKGROUND_ATTENTION_COLOR_GOLD = '#b69700';
export const BACKGROUND_ATTENTION_COLOR_RUBY = RUBY_COLOR;
// Алмазная лига: тот же голубой, что у строки лиги на экране поиска
// рейтингового матча (RankMatchWaiting.css), фон — его затемнение, как у золота
export const DIAMOND_COLOR = '#9be3ec';
export const BACKGROUND_ATTENTION_COLOR_DIAMOND = '#5f8f96';

export const WAR_POLICY_COLOR = '#98172d';
